module.exports = __webpack_public_path__ + "assets/normal/images/defaultAvatar.eb9586d1.png";